import { Mousewheel, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRouter } from "next/router";
import Image from "next/legacy/image";
import { BASE_URL } from "../../utils/FetchData";
import { isMobileContext } from "../../contexts/isMobileContext";
import { useContext, useState } from "react";
import FadeIn from "../Animations/FadeIn";
import Magnitizer from "../Animations/Magnitizer";
const OurPartnerContractors = ({ title, contractors }) => {
    const { locale } = useRouter()
    const { isMobile } = useContext(isMobileContext)
    const [slideNumber, setSlideNumber] = useState(2)
    return (
        <>
            <FadeIn customClass="header">
                <h6 className="_eleX light">{title}</h6>
                {!isMobile &&
                    <div className={`arrows-container
                ${!isMobile && contractors?.length < 6 && 'd-none'}
                `}>
                        <Magnitizer dataDest={1.5}>
                            <div className={`swiper-button-prev swiper-button-prev-${title} contractors-arrow black-arrow-prev`}></div>
                        </Magnitizer>
                        <Magnitizer dataDest={1.5}>
                            <div className={`swiper-button-next swiper-button-next-${title}  contractors-arrow black-arrow-next`}></div>
                        </Magnitizer>
                    </div>
                }
            </FadeIn>
            <FadeIn customClass="swiper-section">
                <Swiper
                    key={title}
                    style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                    modules={[Navigation, Pagination, Mousewheel]}
                    navigation={{
                        nextEl: `.swiper-button-next-${title}`,
                        prevEl: `.swiper-button-prev-${title}`,
                    }}

                    slidesPerView={2}
                    spaceBetween={0}
                    breakpoints={{
                        600: {
                            slidesPerView: 4,
                            spaceBetween: 0
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 0
                        },
                    }}
                    pagination={{
                        type: "progressbar",
                        el: `.swiper-partners-navigation-${title}`,
                    }}
                    onSlideChange={(swiper) => { setSlideNumber(2 + swiper.activeIndex) }}
                // loop={true}
                >
                    {contractors?.map((item, index) => (
                        <SwiperSlide key={index} className="_eleX">
                            <div className="partner-card" key={index}>
                                <div className="img-container">
                                    <Image
                                        src={`${BASE_URL}${isMobile ? item?.img_mobile.data.attributes.url : item?.img_desktop.data.attributes.url}`}
                                        alt={item?.img_mobile.data.attributes.name}
                                        layout={"fill"}
                                        objectFit="cover"
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </FadeIn>
            {isMobile &&
                <div className={`arrows-container ${contractors?.length < 3 && 'd-none'}`}>
                    <Magnitizer dataDest={1.5}>
                        <div className={`swiper-button-prev swiper-button-prev-${title} contractors-arrow black-arrow-prev`}></div>
                    </Magnitizer>
                    <Magnitizer dataDest={1.5}>
                        <div className={`swiper-button-next swiper-button-next-${title}  contractors-arrow black-arrow-next`}></div>
                    </Magnitizer>
                </div>
            }
        </>
    )
}

export default OurPartnerContractors